/*
    Attach this directive to element that you want to scroll to (target)
*/
import { Directive, Input, AfterViewInit, OnDestroy, ElementRef, OnChanges, SimpleChanges } from '@angular/core';

import { SubNavService } from '../sub-nav.shared.service';

@Directive({
    selector: '[directive-sub-nav-register]',
})
export class SubNavRegisterDirective implements AfterViewInit, OnDestroy, OnChanges {
    @Input() public registryId: string;
    @Input() public targetId: number;

    constructor(
        private _subNavService: SubNavService,
        private _elementRef: ElementRef
    ) { }

    ngAfterViewInit(): void {
        if (!this.targetId || !this.registryId) {
            console.warn(`Provide [targetId: number] and [registryId: string] for directive-sub-nav-register`);
            return;
        }
        this._subNavService.registerTarget(this.registryId, this.targetId, this._elementRef.nativeElement);
    }

    ngOnChanges(changes: SimpleChanges): void {
        const c = changes.targetId;
        if (this.registryId && c.previousValue && c.currentValue && c.previousValue !== c.currentValue && c.firstChange === false) {
            this._subNavService.removeTarget(this.registryId, c.previousValue);
            this._subNavService.registerTarget(this.registryId, c.currentValue, this._elementRef.nativeElement);
        }
    }

    ngOnDestroy(): void {
        if (!this.targetId || !this.registryId) return;

        this._subNavService.removeTarget(this.registryId, this.targetId);
    }
}
